import { render } from "./ClausePart.vue?vue&type=template&id=d47619d4&scoped=true"
import script from "./ClausePart.vue?vue&type=script&lang=js"
export * from "./ClausePart.vue?vue&type=script&lang=js"

import "./ClausePart.vue?vue&type=style&index=0&id=d47619d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47619d4"],['__file',"src/components/offersDetails/ClausePart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d47619d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d47619d4', __exports__)) {
    api.reload('d47619d4', __exports__)
  }
  
  module.hot.accept("./ClausePart.vue?vue&type=template&id=d47619d4&scoped=true", () => {
    api.rerender('d47619d4', render)
  })

}


export default __exports__